export const hexToRgb = (hex: string): [number, number, number] => {
  // Remove the # if present
  const cleanHex = hex.replace('#', '');

  // Handle 3-digit hex colors by expanding them to 6 digits
  let fullHex: string;
  if (cleanHex.length === 3) {
    // Expand 3-digit hex: 'fff' -> 'ffffff', '0a5' -> '00aa55'
    fullHex = cleanHex
      .split('')
      .map((char) => char + char)
      .join('');
  } else {
    fullHex = cleanHex;
  }

  const bigint = parseInt(fullHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
};
